var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50083 9.63668L11.7085 13.691C12.1306 14.1009 12.4052 14.1051 12.835 13.691L13.6792 12.8774C14.0928 12.479 14.1208 12.2175 13.6792 11.7919L9.22459 7.50016L13.6796 3.20839C14.0969 2.80502 14.105 2.5328 13.6796 2.12255L12.8354 1.30931C12.3975 0.887205 12.1269 0.906704 11.7089 1.30931L7.50083 5.36365L3.29319 1.30969C2.87515 0.907087 2.60458 0.887587 2.16664 1.30969L1.32243 2.12293C0.896667 2.53318 0.904386 2.80541 1.32243 3.20878L5.77707 7.50016L1.32243 11.7919C0.880823 12.2175 0.904386 12.479 1.32243 12.8774L2.16623 13.691C2.5924 14.1051 2.86703 14.1009 3.29279 13.691L7.50083 9.63668Z",
    fill: "#17142E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d2ab1f1bfabc1a89cc7d9f76735d4fc6.svg";
export { ForwardRef as ReactComponent };